
















































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Directory from '../components/Directory.vue';
import VueApexCharts from 'vue-apexcharts';
import { UserGetters } from '@/modules/users/store/user.getters';
import { contacts, layout, user } from '@/modules/shared/shared/store/namespaces';
import { Actions, FormView, Resources } from '../../../shared/shared/domain/constants/constants';
import {
    CONTACT_SET_CONTACT_TO_UPDATE,
    CONTACT_SET_CUSTOMER,
    CONTACT_SET_FORM_VIEW,
    CONTACT_SET_LAST_ROUTE,
} from '@/modules/contacts/shared/store/contacts.mutations';
import { Contact } from '@/modules/contacts/shared/domain/contact';
import { ContactsActions } from '@/modules/contacts/shared/store/contacts.actions';
import { ContactsGetters } from '@/modules/contacts/shared/store/contacts.getters';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { User } from '@/modules/users/domain/user';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { ContactSelection } from '@/modules/contacts/shared/domain/contact-selection';
import { Customer } from '@/modules/customers/domain/customer';
import { CustomerContact } from '@/modules/contacts/shared/domain/customer-contact';
import ActivateUser from '@/modules/contacts/directory/components/ActivateUser.vue';
import ContactDetail from '@/modules/contacts/directory/components/ContactDetail.vue';

@Component({
    components: {
        ContactDetail,
        ActivateUser,
        Directory,
        apexchart: VueApexCharts,
    },
})
export default class ContactDirectory extends Vue {
    @Prop({ default: false })
    readonly adminUser!: boolean;

    @Prop()
    customer!: any;

    @Prop({ default: false })
    readonly customerManagement!: boolean;

    $refs!: {
        activateModal: any;
        directory: any;
    };

    private withUser: boolean = false;

    activationMode: string = '';
    createAction: string = Actions.CREATE.name;
    privilegeAdministrationResourceName: string = Resources.PRIVILEGE_ADMINISTRATION.name;
    ApexKey: boolean = true;

    loadingContactFailed: boolean = false;

    contact: ContactSelection = {
        id: -1,
        userId: -1,
        name: '',
        lastName: '',
        ci: '',
        position: '',
        email: '',
        phone: '',
        cellphone: '',
        userStatus: {
            id: -1,
            name: '',
        },
        priority: -1,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        contactRoles: {} as any,
        contactType: {
            id: -1,
            name: '',
        },
        contactTypeId: -1,
        contactTypeName: '',
        scalabilityLevel: {
            id: -1,
            name: '',
        },
        scalabilityLevelId: -1,
        scalabilityLevelName: '',
        sgcResources: [],
    };
    contactDeleted: boolean = false;
    contactFormKey: number = 0;
    contactName: string = '';
    contactToModify: any = {};
    deleteDialog: boolean = false;
    deletingContact: boolean = false;
    dialog: boolean = false;
    directoryHeight: number = 716;
    finishedText: string = '';
    lastYear: number = -1;
    loadingContact: boolean = true;
    menu: boolean = false;
    modalCheck: boolean = false;
    snackbar: boolean = false;
    snackbarColor: string = '';
    snackbarText: string = '';

    dialogFullScreen: boolean = true;

    mounted() {
        this.changeTitle({
            title: 'DIRECTORIO DE CONTACTOS',
            route: ['CONTACTOS'],
        });

        this.SET_ROUTE(this.$route.name!);
        if (this.$route.params.message) {
            EventBus.$emit(EventBusMessages.SHOW_SUCCESS, this.$route.params.message);
        }
    }

    reset() {
        this.displayContact(this.currentSelection);
        this.$refs.directory.reset();
        this.reRenderContactForm();
    }

    get customerId(): number {
        const customerId: number = this.currentUser.contact.customer.id;
        if (this.customer && this.customer !== -1) {
            return this.customer.id;
        } else {
            return customerId;
        }
    }

    get isCustomerManagement() {
        return this.customerManagement;
    }

    get isDaycohostUser() {
        return this.currentUser.user.username.search('@daycohost') > 0;
    }

    get options() {
        let options: {
            title: string;
            icon: string;
        }[] = [];

        if (
            this.contact.userStatus!.name !== 'Activo' &&
            this.contact.userStatus!.name !== 'Pendiente' &&
            this.contact.userStatus!.name !== 'Inactivo'
        ) {
            options.push({
                title: 'Crear usuario',
                icon: 'mdi-account-edit',
            });
            options.push({
                title: 'Modificar contacto',
                icon: 'mdi-account-edit',
            });
            this.withUser = false;
        } else {
            options.push({
                title: 'Modificar contacto',
                icon: 'mdi-account-edit',
            });
            this.withUser = true;
        }

        //@ts-ignore
        if (this.$can(this.createAction, this.privilegeAdministrationResourceName)) {
            options.push({
                title: 'Eliminar contacto',
                icon: 'mdi-account-off',
            });
        }

        if (this.contact.userStatus!.name !== '') {
            if (
                this.contact.userStatus!.name === 'Activo' ||
                this.contact.userStatus!.name === 'Pendiente'
            ) {
                options.push({
                    title: 'Inactivar acceso al Portal',
                    icon: 'mdi-account-remove',
                });
            } else {
                options.push({
                    title: 'Activar acceso al Portal',
                    icon: 'mdi-account-check',
                });
            }
        }

        return options;
    }

    activationsDone(success: boolean) {
        this.activationMode = '';
        this.reset();
    }

    closeSnackbar() {
        this.snackbar = false;
        this.snackbarText = '';
    }

    getCustomer() {
        if (this.isDaycohostUser) {
            return this.customer;
        }
        return this.currentUser.contact.customer;
    }

    getContactToCreateTicket() {
        if (this.isDaycohostUser) {
            return this.contact;
        }

        return this.currentUser.contact;
    }

    async deleteContact() {
        this.finishedText = `El contacto ${this.contact.name} ${this.contact.lastName} ha sido eliminado exitosamente`;
        this.deletingContact = true;
        this.deleteDialog = false;
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        const customer = this.getCustomer();

        const failed = await this.deleteAContact({
            contact: this.contact,
            userContact: this.currentUser.contact,
            customer,
            isDaycoUser: this.isDaycohostUser,
        });

        if (failed) {
            failed.showError();
        } else {
            EventBus.$emit(EventBusMessages.SHOW_SUCCESS, this.finishedText);
            this.reset();
        }
        this.contactDeleted = true;

        setTimeout(() => {
            EventBus.$emit(EventBusMessages.HIDE_LOADER);
        }, 350);
    }

    async displayContact(contact: Contact | ContactSelection) {
        this.loadingContact = true;
        this.resetContact();

        let contactId: number = contact.id;
        const failed = await this.selectContactInDirectory(contactId);

        if (failed) {
            failed.showError();
        } else {
            this.contact = this.currentSelection;
        }

        this.loadingContact = false;
    }

    executeOptionFunction(option: string) {
        this.SET_CUSTOMER(this.customer || this.currentUser.contact.customer);

        if (option === 'Crear usuario') {
            this.reRenderContactForm();

            this.contactToModify = this.contact;
            this.contactToModify.contactId = this.contact.id;
            this.contactToModify.contactType = {
                id: this.contact.contactTypeId,
                name: this.contact.contactTypeName,
            };
            this.contactToModify.nationality = this.contact.ci[0] == 'E' ? 'E' : 'V';
            this.SET_CONTACT_TO_UPDATE(this.contactToModify);
            this.SET_FORM_VIEW(FormView.CREATING_USER);

            this.$router.push('/portal/update-contact');
            this.dialogFullScreen = true;
            this.dialog = true;
            this.dialogFullScreen = true;
        } else {
            if (option === 'Modificar contacto') {
                this.reRenderContactForm();
                this.contactToModify = this.contact;
                this.contactToModify.contactId = this.contact.id;
                this.contactToModify.contactTypeId = this.contact.contactTypeId;
                this.contactToModify.contactTypeName = this.contact.contactTypeName;
                this.contactToModify.priority = this.contact.priority;
                this.contactToModify.contactType = {
                    id: this.contact.contactTypeId,
                    name: this.contact.contactTypeName,
                };
                this.contactToModify.nationality = this.contact.ci[0] == 'E' ? 'E' : 'V';
                this.SET_CONTACT_TO_UPDATE(this.contactToModify);
                if (this.withUser) {
                    this.SET_FORM_VIEW(FormView.UPDATING);
                } else {
                    this.SET_FORM_VIEW(FormView.UPDATING_WITHOUT_USER);
                }

                this.$router.push('/portal/update-contact');
                this.dialog = true;
                this.dialogFullScreen = true;
            } else {
                if (option === 'Eliminar contacto') {
                    this.openDeleteDialog();
                } else {
                    this.reRenderContactForm();
                    if (option === 'Activar acceso al Portal') {
                        this.activationMode = 'activate';
                    } else {
                        this.activationMode = 'deactivate';
                    }
                    this.contactToModify = this.contact;
                    this.contactToModify.contactId = this.contact.id;
                    this.contactToModify.contactTypeId = this.contact.contactTypeId;
                    this.contactToModify.contactTypeName = this.contact.contactTypeName;
                    this.contactToModify.priority = this.contact.priority;
                    this.contactToModify.contactType = {
                        id: this.contact.contactTypeId,
                        name: this.contact.contactTypeName,
                    };
                    this.$refs.activateModal.openModal();
                }
                this.dialogFullScreen = false;
            }
        }

        this.menu = false;
    }

    extractTotalTicketsPerMonth(startingMonth: number, tickets: any) {
        let data: number[] = [];

        let month: number = startingMonth;
        let j: number = 0;

        for (let i = 1; i < 13; i++) {
            if (month === 13) {
                month = 1;
            }

            if (j < tickets.length) {
                if (tickets[j].monthNumber === month) {
                    data.push(tickets[j].total);
                    j++;
                } else {
                    data.push(0);
                }
            } else {
                data.push(0);
            }
            month++;
        }

        return data;
    }

    openDeleteDialog() {
        this.deletingContact = false;
        this.contactDeleted = false;
        this.deleteDialog = true;
    }

    reRenderContactForm() {
        this.contactToModify = {};

        if (this.contactFormKey !== 0) {
            this.contactFormKey = 0;
        } else {
            this.contactFormKey = 1;
        }
        this.dialogFullScreen = true;
    }

    resetContact() {
        this.contact = {
            id: -1,
            userId: -1,
            name: '',
            lastName: '',
            ci: '',
            position: '',
            email: '',
            phone: '',
            cellphone: '',
            userStatus: {
                id: -1,
                name: '',
            },
            contactType: {
                id: -1,
                name: '',
            },
            contactTypeId: -1,
            contactTypeName: '',
            scalabilityLevel: {
                id: -1,
                name: '',
            },
            scalabilityLevelId: -1,
            scalabilityLevelName: '',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            contactRoles: {} as any,
            sgcResources: [],
        };
    }

    displayContactNames(lastName: string, name: string) {
        if (lastName) {
            if (name) {
                return lastName + ', ' + name;
            } else {
                return lastName;
            }
        } else {
            if (name) {
                return name;
            } else {
                return 'No especificado';
            }
        }
    }

    @contacts.Mutation(CONTACT_SET_CONTACT_TO_UPDATE) SET_CONTACT_TO_UPDATE!: (
        contact: Contact,
    ) => void;

    @contacts.Mutation(CONTACT_SET_FORM_VIEW) SET_FORM_VIEW!: (view: string) => void;

    @contacts.Mutation(CONTACT_SET_CUSTOMER) SET_CUSTOMER;

    @contacts.Mutation(CONTACT_SET_LAST_ROUTE)
    SET_ROUTE!: (route: string) => void;

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (title: LayoutTitle) => void;

    @contacts.Action(ContactsActions.DELETE_CONTACT)
    deleteAContact!: (params: {
        contact: ContactSelection;
        customer: Customer;
        userContact: Contact;
        isDaycoUser: boolean;
    }) => Promise<RequestResponse>;

    @contacts.Action(ContactsActions.SELECT_CONTACT_IN_DIRECTORY)
    selectContactInDirectory!: (contactId: number) => Promise<RequestResponse>;

    @contacts.Getter(ContactsGetters.GET_CURRENT_SELECTED_CONTACT_RESOURCES)
    contactPrivileges!: string;

    @user.Getter(UserGetters.IS_CONTACT_ADMINISTRATOR)
    isContactAdministrator!: boolean;

    @user.Getter(UserGetters.GET_CURRENT_USER)
    currentUser!: User;

    @contacts.Getter(ContactsGetters.GET_DIRECTORY)
    customerContacts!: CustomerContact[];

    @contacts.Getter(ContactsGetters.GET_CURRENT_SELECTION)
    currentSelection!: ContactSelection;
}
